import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { BsArrowBarLeft, BsArrowBarRight } from 'react-icons/bs';

import { type DoubleElements, type PageElement } from '@editor2/types/pageElements';
import { type RootState } from '@editor2/reducers/root';
import {
	getElementHumanName,
	getElementSubtype,
	isDoubleElement
} from '@editor2/services/elementService';

interface Props {
	courseId: number;
	pageId: string;
	element: PageElement;
	onCollapse: () => void;
}

const ElementNameBlock: FC<Props> = (props) => {
	const { courseId, pageId, element, onCollapse } = props;

	const { config, pages } = useSelector((state: RootState) => state.courses[courseId]);

	const getElementName = () => {
		const pageType = pages.entities[pageId].page_type;
		const elementHumanName = getElementHumanName(config, pageType, element);

		return elementHumanName || element.type;
	};

	return (
		<div className="headerText" onClick={onCollapse}>
			<span className="type">
				{getElementName()} {getElementSubtype(element)}{' '}
				{isDoubleElement(element.type) && (element as DoubleElements).direction === 'in' && (
					<BsArrowBarRight />
				)}
				{isDoubleElement(element.type) && (element as DoubleElements).direction === 'out' && (
					<BsArrowBarLeft />
				)}
			</span>
		</div>
	);
};

export default ElementNameBlock;
